<script>
// this file is a mixin file for repeated method and data and ... for forms

export default {
  data() {
    return {
      lengthNumber3: 3,
      lengthNumber5: 5,
      lengthNumber6: 6,
      lengthNumber8: 8,
      lengthNumber10: 10,
      lengthNumber11: 11,
      lengthNumber16: 16,
      lengthNumber32: 32,
      lengthNumber64: 64,
      lengthNumber150: 150,
      lengthNumber256: 256,
      lengthNumber512: 512,
      lengthNumber1024: 1024,
      lengthNumber3000: 3000,
      codeLength: process.env.VUE_APP_OTP_CODE_LENGTH,
      captchaLength: process.env.VUE_APP_CAPTCHA_LENGTH,
      showCaptcha: false,
    };
  },
  methods: {
    input(key, value) {
      // set input value by key in form inputs
      this.form[key] = value;
    },
    checkValidation(key, value) {
      // check validation and reset when value in null
      this.$v.form[key].$touch();
      value && this.$v.form[key].$reset();
    },
    resetValidation(key) {
      // reset input by key
      // this.$v.form[key].$reset();
    },
    resetForm() {
      // reset all value and errors in form inputs
      Object.keys(this.form).forEach((key) => (this.form[key] = null));
      this.$v.$reset();
    },
    updateCaptchaKey(value) {
      // set captchaKey value in form inputs
      this.form.captchaKey = value;
    },
    setShowCaptcha(value) {
      // set showCaptcha value in data
      this.showCaptcha = value;
    },
  },
};
</script>
